import React from 'react'

import { KeyPairValueKeys, useGetKeyPairValue } from 'api/core/useAPIKeyValue'
import useSearchQuery from 'app/SearchPage/hooks/useSearchQuery'

import type {
  TResponseSuccessGetContentSearchWhitelistResult,
  TContentSearchWhitelist,
} from 'types/content-search'

const useSearchWhitelistResults = () => {
  const { searchQueryFromURL } = useSearchQuery()
  const {
    data: responseData,
    isSuccess,
    isFetched,
  } = useGetKeyPairValue<TResponseSuccessGetContentSearchWhitelistResult>(
    KeyPairValueKeys.ContentSearchWhitelists
  )

  const whitelistsData = React.useMemo<TContentSearchWhitelist[]>(
    () => (isSuccess ? responseData?.data?.whitelist : []),
    [isSuccess, responseData?.data]
  )

  const whitelistResults = React.useMemo(
    () =>
      (whitelistsData ?? [])
        .filter(({ key }) =>
          key
            .map((item) => item.toLowerCase().replace(/\s/g, ''))
            .includes(
              (searchQueryFromURL ?? '').toLowerCase().replace(/\s/g, '')
            )
        )
        .map(({ content }) => content),
    [searchQueryFromURL, whitelistsData]
  )

  const whitelistResultsCount = React.useMemo(
    () => (whitelistResults ?? []).length ?? 0,
    [whitelistResults]
  )

  const hasWhitelistResults = React.useMemo(
    () => whitelistResultsCount > 0,
    [whitelistResultsCount]
  )

  return {
    whitelistsData,
    whitelistsDataFetched: isFetched,
    whitelistResults,
    whitelistResultsCount,
    hasWhitelistResults,
  }
}

export default useSearchWhitelistResults
